var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-5",attrs:{"align":"center"}},[_c('br'),_c('br'),_c('v-icon',{attrs:{"size":"70","color":"primary"}},[_vm._v("mdi-weather-partly-snowy-rainy")]),_c('h1',[_vm._v("¡Ups!")]),_c('p',[_vm._v("Nada que mostrar")]),_c('p',[_vm._v("¡Vuelve pronto!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }